import { render, staticRenderFns } from "./InventoryAdmin.vue?vue&type=template&id=a0d2f49e&scoped=true"
import script from "./InventoryAdmin.vue?vue&type=script&lang=js"
export * from "./InventoryAdmin.vue?vue&type=script&lang=js"
import style0 from "./InventoryAdmin.vue?vue&type=style&index=0&id=a0d2f49e&prod&lang=css"
import style1 from "./InventoryAdmin.vue?vue&type=style&index=1&id=a0d2f49e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d2f49e",
  null
  
)

export default component.exports